import React from 'react';

const Header = () => {
    return (
        <div className='header'>
            <h1>NC Games</h1>
            </div>
    )
}

export default Header;